export default __webpack_public_path__ + "static/media/3H.cba17cfa.svg";